<template>
  <div class="diabox">
    <template v-if="data">
    <div class="exp">
      <div><div>交易金額</div><div>{{formatDollarInt(data.TradeAmt)}}</div></div>
      <div><div>付款時間</div><div>{{data.PaymentDate}}</div></div>
      <div><div>付款方式</div><div>{{data.PaymentTypeZh || data.PaymentType}}</div></div>
      <div v-if="data.PaymentTypeZh==='信用卡'"><div>卡號</div><div>{{data.card6no}}********{{data.card4no}}</div></div>
      <div><div>交易狀態</div><div>{{data.ecRefund?.status || data.ecRefund?.Status || TradeStatus}}</div></div>
      <div><div>手續費合計</div><div>{{formatDollarInt(data.HandlingCharge)}}</div></div>
      <div><div>特店交易編號</div><div>{{data.MerchantTradeNo}}</div></div>
      <div><div>綠界交易編號</div><div>{{data.TradeNo}}</div></div>
      <div><div>商品名稱</div><div>{{data.ItemName}}</div></div>
      <div v-if="data.CloseData&&data.CloseData.length>0&&data.CloseData.slice(-1)[0]">
        <div>{{data.CloseData&&data.CloseData.slice(-1)[0]&&0>data.CloseData.slice(-1)[0].Amount ? '退刷金額' : '請款金額'}}</div>
        <div>{{data.CloseData.slice(-1)[0].Amount}}</div>
      </div>
    </div>
    <div class="btns" :class="(((data.ecRefund && data.ecRefund.Status === 'Cancelled'))||(data.CloseData&&data.CloseData.length>0&&data.CloseData.slice(-1)[0]&&0>data.CloseData.slice(-1)[0].Amount)) && 'b1'">
      <button :style="{backgroundColor:'#CACACA'}" @click="$emit('close')">取消</button>
      <button v-if="!(data.ecRefund && data.ecRefund.Status === 'Cancelled')&&!(data.CloseData&&data.CloseData.length>0&&data.CloseData.slice(-1)[0]&&0>data.CloseData.slice(-1)[0].Amount)" :disabled="waiting" :style="{backgroundColor:'var(--highlight)'}" @click="$emit('refund')">退款</button>
    </div>
    </template>
    <template v-else>
    <div class="error">{{error}}</div>
    <div class="btns b1">
      <button :style="{backgroundColor:'#CACACA'}" @click="$emit('close')">關閉</button>
    </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ['data', 'error', 'waiting'],
  computed: {
    data2 () {
      return Object.assign({}, ...Object.keys(this.data).filter(e => this.data[e]).map(k => { return { [k]: this.data[k] } }))
    },
    TradeStatus () {
      switch (parseInt(this.data.TradeStatus)) {
        case 0:
          return '未付款'
        case 1:
          return '已付款'
        case 10200095:
          return '交易訂單未成立'
        default:
          return ''
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.btns {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 35px;
  height: 60px;
  button {
    font-size: 20px;
    letter-spacing: .05em;
    color: #FFFFFF;
    border-radius: 3px;
    &:disabled {
      filter: contrast(.5);
    }
  }
  &.b1 {
    grid-template-columns: 1fr;
  }
}
.diabox {
  padding: 20px 40px;
  display: flex;
  flex-direction: column;
  gap: 40px;
}
.exp>div {
  display: grid;
  align-items: center;
  grid-template-columns: 130px 1fr;
  text-align: start;
  align-items: center;
  height: 40px;
  font-size: 18px;
}
</style>
